export default "__VITE_ASSET__BhnQNbxW__"